import React, { Component } from 'react';
import {navigateTo} from "gatsby-link";
import styled, {css} from "react-emotion";
import colors from "../../utils/colors.js";

const FormStyle = css `
  margin: 0 0 1em 0;
  width: 100%;
`;

const MessageStyle = css `
  width: 100%;
  margin: 0 0 1em 0;
  line-height: 1.6;
  min-height: 250px;
  resize: vertical;
`;

const basicButton = css `
  width: 100%;
  text-align: center;
  padding: 1rem 3rem;
  font-weight: 600;
  transition: all 0.3s ease 0s;
  border: 2px solid ${colors.black};
`;

const primaryButton = css `
  ${basicButton}
  color: white;
  background-color: ${colors.black};

  &:hover {
    cursor: pointer;
    color: ${colors.black};
    background-color: white;
  }
`;

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

export default class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};

  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = e => {
    fetch("/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: encode({
        "form-name": "contact",
        ...this.state
      })
    }).then(() => navigateTo('/thanks'))
      .catch(error => alert(error));

    e.preventDefault();
  };

  render() {
    return (
      <div>
        <form
          name="contact"
          method="post"
          action="/thanks/"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={this.handleSubmit}
        >
          <p hidden>
            <label>
              Don’t fill this out:
              <input name="bot-field" onChange={this.handleChange} />
            </label>
          </p>
          <div>
            <label htmlFor="name">Name</label>
            <input className={FormStyle} type="text" name="name" onChange={this.handleChange} required />
          </div>
          <div>
            <label htmlFor="email">Email</label>
            <input type="text" className={FormStyle} name="email" onChange={this.handleChange} required />
          </div>
          <div>
            <label htmlFor="message">Message</label>
            <textarea name="message" onChange={this.handleChange} className={MessageStyle} rows="6" required></textarea>
          </div>
          <button type="submit" className={primaryButton}>Send Message</button>
        </form>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js